// extracted by mini-css-extract-plugin
module.exports = {"Background":"main_Background__nw5oi","Overlay":"main_Overlay__mPTgt","Content":"main_Content__6yEdi"};